/**
 * Libera — the agents app. Your work is done by named agents, each with its own memory and its
 * own conversations; around them, the portfolio, the workers, the connections and the settings.
 * The screens from before agents are still at /classic.html, reading the same data.
 */
import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import './app.css'
import { startLegacyBridge } from './legacy'
import { Shell } from './Shell'
import { Join } from './Join'
import { SignIn } from './SignIn'
import { startRouting, useDemo } from './store'

function App() {
  const ready = useDemo((s) => s.ready)
  const user = useDemo((s) => s.user)
  useEffect(() => {
    if (!user) return
    startRouting()
  }, [!!user]) // eslint-disable-line react-hooks/exhaustive-deps
  if (!ready) return <div className="ws h-full bg-ws-bg" />
  // An invitation link (/join/<token>) opens the join page for someone who is not signed in.
  const invite = location.pathname.match(/^\/join\/([\w-]+)/)
  if (!user && invite) return <Join token={invite[1]} />
  return user ? <Shell /> : <SignIn />
}

startLegacyBridge()
void useDemo.getState().init()
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
